import { AlertTriangle, CheckCircle2, Loader2 } from "lucide-react"

import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

interface AgentExecutionStatusBadgeProps {
  status: string
}

export default function AgentExecutionStatusBadge({
  status,
}: AgentExecutionStatusBadgeProps) {
  const normalizedStatus = status.toLowerCase()

  // Map status to display configuration
  let displayText: string
  let icon: React.ReactNode
  let className: string

  if (normalizedStatus === "success" || normalizedStatus === "completed") {
    displayText = "Success"
    icon = <CheckCircle2 className="h-3 w-3" />
    className =
      "bg-green-50 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-400 dark:border-green-800"
  } else if (
    normalizedStatus === "running" ||
    normalizedStatus === "in process" ||
    normalizedStatus === "inprogress"
  ) {
    displayText = "In progress"
    icon = <Loader2 className="h-3 w-3 animate-spin" />
    className =
      "bg-gray-50 text-gray-700 border-gray-200 dark:bg-gray-950 dark:text-gray-400 dark:border-gray-800"
  } else if (
    normalizedStatus === "error" ||
    normalizedStatus === "failed" ||
    normalizedStatus === "attention" ||
    normalizedStatus === "attention required"
  ) {
    displayText = "Attention"
    icon = <AlertTriangle className="h-3 w-3" />
    className =
      "bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-950 dark:text-yellow-400 dark:border-yellow-800"
  } else {
    // Default/unknown status
    displayText = status
    className =
      "bg-gray-50 text-gray-700 border-gray-200 dark:bg-gray-950 dark:text-gray-400 dark:border-gray-800"
  }

  return (
    <Badge variant="outline" className={cn("gap-1", className)}>
      {icon}
      {displayText}
    </Badge>
  )
}
